import { IMenuButton } from '@principle-theorem/editor';
import { MenuButtonLoaderFn } from '@principle-theorem/ng-prosemirror';
import { BasicMenuButtonComponent } from '../../../menu-bar/basic-menu-button/basic-menu-button.component';
import { AIMenuButtonFilters } from '../ai-menu-button-filters';

export function createSummarizeButton(): MenuButtonLoaderFn<
  BasicMenuButtonComponent,
  IMenuButton
> {
  return () => ({
    component: BasicMenuButtonComponent,
    data: {
      buttonType: 'submenu-detail',
      buttonText: 'Summarise',
      tooltip: `Summarises your text`,
      icon: 'summarize',
      command: (editor) => editor.chain().focus().aiSummarize().focus().run(),
      isDisabledFn: (editor) =>
        AIMenuButtonFilters.disableWithoutTextSelection(editor),
    },
  });
}
